import z from 'zod';

export const ZTokenSchema = z.object({
  accessToken: z.string(),
  refreshToken: z.string(),
  expireAt: z.string(),
  tokenType: z.string(),
});
